import Fetch from "./index";

export const getAgendorIntegrationById = async (id) => {
    if (!id)
        return Promise.reject("failed to read id");

    return Fetch("/agendor-integration/" + id)
}

export const getAgendorIntegration = async ({assistantID}) => {
    if (!assistantID)
        return Promise.reject("failed to read id");

    return Fetch("/agendor-integration/?assistantID=" + assistantID)
}

export const getAgendorIntegrations = async () => {
    return Fetch("/agendor-integration")
}

export const createAgendorIntegration = async (body) => {
    const data = new FormData();
    for (const key in body) {
        if (Array.isArray(body[key])) {
            for (const value of body[key]) {
                data.append(key+"[]", value);
            }
            continue
        }
        data.set(key, body[key]);
    }

    return Fetch(
        '/agendor-integration/',
        {
            method: 'POST',
            body: data,
        },
    )
}

export const deleteAgendorIntegration = async (id) => {
    return Fetch(
        '/agendor-integration/' + id,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const updateAgendorIntegration = async (id, body) => {
    delete body['createdAt']
    delete body['updatedAt']
    delete body['deletedAt']
    delete body['id']

    const data = new FormData();
    for (const key in body) {
        if (Array.isArray(body[key])) {
            for (const value of body[key]) {
                data.append(key+"[]", value);
            }
            continue
        }

        data.set(key, body[key]);
    }

    return Fetch(
        '/agendor-integration/' + id,
        {
            method: 'PUT',
            body: data,
        },
    )
}
